import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';

import { Slide } from 'react-slideshow-image';
import SlideShow from './SlideShow'

import '../css/OpenSlideShow.css';

class OpenSlideShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_lang: this.props.lang,
      startAnimate: false,
      slideImages: ["/assets/mainpage_home1-1.webp", "/assets/mainpage_home1-2.webp", "/assets/mainpage_home1-3.webp"],
      slideTitle: {
        "zh": ["AI Robots, Ready to Work.", "AI Robots, Ready to Work.", "AI Robots, Ready to Work."], 
        "en": ["AI Robots, Ready to Work.", "AI Robots, Ready to Work.", "AI Robots, Ready to Work."], 
        "ja": ["AI Robots, Ready to Work.", "AI Robots, Ready to Work.", "AI Robots, Ready to Work."]},
      slideContent: {
        "zh": ["Nexuni 耐思尼致力於推動 AI 機器人技術的落地，解決產業缺工及高危險職缺無人可補的問題。我們的目標是縮短機器人與實際應用之間的落差，打造真正能投入現場工作的機器人。", "我們是 Universal Robots 認證的 Solution Provider以及Distributor，若有機器手臂解決方案的開發需求或採購，請聯絡我們。", "Nexuni 致力於將 AI 整合於硬體系統，我們與 NVIDIA 密切合作，參與他們的 Inception Program，使用最先進的硬體設備和軟體框架來開發 AI 機器人。"], 
        "en": ["Nexuni is committed to promoting the implementation of AI robotics technology to solve the problems of labor shortages and high-risk positions that cannot be filled. Our goal is to bridge the gap between robots and practical applications, creating robots that can truly be deployed in field operations.", "Nexuni is the Certified Solution Provider and Distributor of Universal Robots. If you have any development or procurement needs for robotic arm solutions, please contact us.", "Nexuni is committed to integrating AI with hardware systems. We work closely with NVIDIA, participating in their Inception Program, using cutting-edge hardware and software frameworks to develop AI robots."], 
        "ja": ["Nexuniは、AIロボット技術の実用化を推進し、産業界の人手不足や高リスク職種の補充困難な問題を解決することに専念しています。私たちの目標は、ロボットと実際の応用との間のギャップを縮小し、現場作業に実際に投入できるロボットを構築することです。", "Nexuniは、Universal Robots認定のソリューションプロバイダーおよびディストリビューターです。ロボットアームのソリューションに関する開発や調達のニーズがある場合は、ぜひご連絡ください。", "Nexuniは、AIをハードウェアシステムと統合することに専念しています。私たちはNVIDIAと密接に協力し、Inception Programに参加して、最先端のハードウェアとソフトウェアフレームワークを使用してAIロボットを開発しています。"]},
      slideAction: [""]
    }
  }

  componentDidMount() {
    this.setState({
      startAnimate: true
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ current_lang: nextProps.lang });
    }
  }
  
  render() {

        return (
          <>
            <div className={"opening_section "+this.state.current_lang}>

                <div className="slide_area"
                  style={{
                    animation: "fade-in 3s ease 3.5s forwards"
                  }}>
                  <SlideShow version={"v2_"} lang={this.state.current_lang} title={this.state.slideTitle[this.state.current_lang]} content={this.state.slideContent[this.state.current_lang]} action={this.state.slideAction} img={this.state.slideImages} img_num={this.state.slideImages.length} arrow_flag={true} logo_flag={false}/>
                </div>

                <div className="opening_area_x_logo">
                  <img id="opening_area_x_logo_l" src="/assets/mainpage_nexuni_opening_l.svg" alt="blk-r" 
                    style={{
                      animation: "move-right 1.5s ease 0s forwards, fade-out 3s ease 0.75s forwards"
                    }}/>
                  <img id="opening_area_x_logo_r" src="/assets/mainpage_nexuni_opening_r.svg" alt="blk-l" 
                    style={{
                      animation: "move-left 1.5s ease 0s forwards, fade-out 3s ease 0.75s forwards"
                    }}/>
                </div>

                <div className="opening_area_nexuni_logo">
                  <img id="opening_area_nexuni_logo_n1" src="/assets/mainpage_nexuni_n.svg" alt="n" 
                    style={{
                      animation: "fade-in 3s ease 1.5s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_e" src="/assets/mainpage_nexuni_e.svg" alt="e" 
                    style={{
                      animation: "fade-in 3s ease 1.8s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_x" src="/assets/mainpage_nexuni_x.svg" alt="x" 
                    style={{
                      animation: "fade-in 3s ease 2.1s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_u" src="/assets/mainpage_nexuni_u.svg" alt="u" 
                    style={{
                      animation: "fade-in 3s ease 2.4s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_n2" src="/assets/mainpage_nexuni_n.svg" alt="n" 
                    style={{
                      animation: "fade-in 3s ease 2.7s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_i" src="/assets/mainpage_nexuni_i.svg" alt="i" 
                    style={{
                      animation: "fade-in 3s ease 3s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                </div>

            </div>
          </>
        ) 
  }
}
export default OpenSlideShow;


// import React from 'react';
// import { Slide } from 'react-slideshow-image';

// const properties = {
//   duration: 5000,
//   transitionDuration: 500,
//   infinite: true,
//   indicators: true,
//   arrows: true,
//   onChange: (oldIndex, newIndex) => {
//     console.log(`slide transition from ${oldIndex} to ${newIndex}`);
//   }
// }

// const Slideshow = () => {
//     return (
//       <div className="slide-container">
//         <Slide {...properties}>
//           <div className="each-slide">
//             <div style={{'backgroundImage': `url(${slideImages[0]})`}}>
//               <span>Slide 1</span>
//             </div>
//           </div>
//           <div className="each-slide">
//             <div style={{'backgroundImage': `url(${slideImages[1]})`}}>
//               <span>Slide 2</span>
//             </div>
//           </div>
//           <div className="each-slide">
//             <div style={{'backgroundImage': `url(${slideImages[2]})`}}>
//               <span>Slide 3</span>
//             </div>
//           </div>
//         </Slide>
//       </div>
//     )
// }
